import { store } from '@/app/store';
import { createSelector } from '@reduxjs/toolkit';

const EMPTY_ARRAY = [];
const EMPTY_OBJ = {};

export const selectAllRecentChats = state => state.recentChatData?.chats || EMPTY_ARRAY;

export const selectRecentChatInviteUserCount = state => state.recentChatData?.inviteUserCount || 0;

export const selectChatById = (state, chatId) => {
   const chats = selectAllRecentChats(state);
   return chats.find(c => c.fromUserId === chatId);
};

export const selectChatEntities = state => {
   const chats = selectAllRecentChats(state);
   const entities = {};
   chats.forEach(chat => {
      entities[chat.fromUserId] = chat;
   });
   return entities;
};

export const selectRecentChatEntities = selectChatEntities;

export const selectOrderedRecentChats = createSelector([selectAllRecentChats], chats => {
   // Filter out archived for the main recent list
   return chats.filter(chat => chat.archiveStatus !== 1);
});

const getLastRecentChatSelector = createSelector([selectOrderedRecentChats], recentChats => {
   return recentChats[recentChats.length - 1];
});

export const getLastRecentChat = () => getLastRecentChatSelector(store.getState());

export const getChatObject = chatId => selectChatById(store.getState(), chatId);
export const getArchiveStatus = chatId => getChatObject(chatId)?.archiveStatus || 0;
export const selectChatObject = chatId => state => selectChatById(state, chatId);
export const selectHasMore = state => state.recentChatData.hasMore;
export const selectSearchText = state => state.recentChatData.searchText;
export const selectUserInfo = state => state.userInfoData?.users || EMPTY_OBJ;

export const selectSearchTextByScope = scopeKey => state => state.recentChatData.searchTextByScope[scopeKey] || '';

export const selectArchivedChatIds = state => state.recentChatData?.archivedChatIds || EMPTY_ARRAY;

export const selectFilteredRecentChatData = scopeKey =>
   createSelector(
      [selectOrderedRecentChats, selectSearchTextByScope(scopeKey), selectUserInfo],
      (recentChats, searchText, userInfo) => {
         if (!searchText) return recentChats;
         const lowerSearchText = searchText.toLowerCase();
         return recentChats.filter(chat => {
            const userProfile = userInfo[chat.fromUserId] || {};
            return userProfile.nickName?.toLowerCase().includes(lowerSearchText);
         });
      },
   );

export const selectArchivedChats = createSelector(
   [selectAllRecentChats, selectSearchTextByScope('archived'), selectUserInfo],
   (allChats, searchText, userInfo) => {
      const archived = allChats.filter(chat => chat.archiveStatus === 1);
      if (!searchText) return { archived, searchText };
      const lowerSearch = searchText.toLowerCase();
      const filteredArchived = archived.filter(chat => {
         const userProfile = userInfo[chat.fromUserId] || {};
         return userProfile.nickName?.toLowerCase().includes(lowerSearch);
      });
      return { archived: filteredArchived, searchText };
   },
);

// Legacy/Compatibility exports if needed
export const selectRecentChatData = selectRecentChatEntities;
export const selectRecentChatDataById = selectChatById;
export const getRecentChatDataById = getChatObject;
